<div class="flex items-center justify-center h-full">
  <form
    [formGroup]="authenticationForm"
    (ngSubmit)="onSubmit()"
    class="bg-white px-4 py-8 sm:p-8 shadow-md rounded-lg w-full max-w-[420px]"
  >
    <div class="logo-bar">
      <img src="assets/maxbrain-logo.svg" alt="MaxBrain" />
    </div>

    <div class="flex items-center justify-between mb-6">
      <ng-icon
        name="heroArrowLeftSolid"
        class="w-8 h-8"
        color="black"
        size="24px"
        class="cursor-pointer"
        routerLink="/"
      />
      <h2
        class="font-bold text-[28px] leading-8 tracking-normal text-center flex-grow text-[var(--color-darkgraytextcolor)]"
      >
        Authentication
      </h2>
    </div>

    <!-- Code Field -->
    <div class="mb-6">
      <label
        for="code"
        class="font-normal text-sm leading-5 tracking-normal text-[var(--color-darkgraytextcolor)]"
        >Code</label
      >
      <input
        id="code"
        type="text"
        formControlName="code"
        class="w-full p-2 border border-[#E0E0E0] rounded mt-2 h-[52px] focus:ring-0 focus:border-[#E0E0E0] focus:outline-none"
      />
    </div>

    <button
      type="submit"
      [disabled]="authenticationForm.invalid"
      class="w-full bg-[var(--color-primary-600)] cursor-pointer disabled:cursor-not-allowed text-white font-medium py-2 rounded mt-4 disabled:opacity-25 h-[48px]"
    >
      Continue
    </button>
  </form>
</div>
